/** Notação HTML de cor: #RGB, #RRGGBB ou #RRGGBBAA. */

export function isHtmlHexColor(value) {
    const trimmed = String(value || '').trim();
    return /^#([0-9a-fA-F]{3}|[0-9a-fA-F]{6}|[0-9a-fA-F]{8})$/.test(trimmed)
        || /^([0-9a-fA-F]{3}|[0-9a-fA-F]{6})$/.test(trimmed);
}

/** Normaliza para #RRGGBB (lowercase). */
export function normalizeHtmlHex(value) {
    let hex = String(value || '').trim();
    if (!hex) {
        return '';
    }
    if (!hex.startsWith('#')) {
        hex = `#${hex}`;
    }
    if (hex.length === 4) {
        const r = hex[1];
        const g = hex[2];
        const b = hex[3];
        hex = `#${r}${r}${g}${g}${b}${b}`;
    }
    if (hex.length >= 7) {
        return hex.slice(0, 7).toLowerCase();
    }
    return hex.toLowerCase();
}

export function htmlHexForColorInput(value, fallback = '#808080') {
    if (isHtmlHexColor(value)) {
        return normalizeHtmlHex(value);
    }
    return fallback;
}
